import { RouteConfig } from 'vue-router'
import { Store } from 'vuex'

function idToNumber (route) {
  return {
    id: parseInt(route.params.id)
  }
}

export function createPartnersRoutes (store: Store<any>): RouteConfig[] {
  return [
    {
      path: '/socios',
      name: 'partners',
      component: () => import(/* webpackChunkName: "partners" */ '../views/Partners.vue'),
      meta: { requiresAuth: true },
      beforeEnter (to, from, next) {
        store.commit('setShowMenu', true);
        // partnersStore.state.commit('setShowMenu', true, { root: true })
        next()
      }
    },
    {
      path: '/perfil/:id',
      name: 'profile',
      component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
      props: idToNumber,
      meta: { requiresAuth: true }
    },
    {
      path: '/miperfil',
      name: 'myprofile',
      component: () => import(/* webpackChunkName: "myprofile" */ '../views/MyProfile.vue') ,
      meta: { requiresAuth: true }
    },
    {
      path: '/registrate',
      name: 'registro',
      component: () => import(/* webpackChunkName: "registro" */ '../views/Register.vue'),

      beforeEnter (to, from, next) {
        store.commit('setShowMenu', false);
        // this.$store.
        // globalStore.state.commit('setShowMenu', true);
        next()
      }
    }
  ]
}
